<template>
  <ShortcutWrapper :nShortcutRequiredClaim="UserClaims.GlobalAdmin" @n-shortcut="mutate(null, 'create')">
    <v-container fluid id="end-use-sort-settings">

      <Dialog
      :stateId="dialogId"
      maxWidth="400px"
      @click:outside="close"
      @dialog-closing="close"
      @close="close">

        <ConfirmDelete
        v-if="deleting"
        :title="$t('endUseSort')"
        @delete="performDelete"
        @cancel-delete="close"/>

        <EndUseSortForm
        v-else
        :propEndUseSort="endUseSort"
        @end-use-sort-mutated="refresh"/>

      </Dialog>

      <DataTable
      defaultHeight="calc(100vh - 620px)"
      :items="allEndUseSorts"
      :headers="headers"
      :customCells="customCells"
      :actions="tableActions"
      :loading="endUseSortsLoading"
      :showDense="false"
      @refresh="refresh"
      @new-end-use-sort="mutate(null, 'create')"
      style="max-width: 1000px;">

        <template #actions="{ item }">
          <Icon
          icon="mdi-pencil"
          :tooltipText="$t('edit')"
          @icon-clicked="mutate(item, 'edit')"
          :disabled="!userAssignedClaim(UserClaims.GlobalAdmin)"
          elementId="end-use-sort-edit"/>

          <Icon
          icon="mdi-delete-forever"
          :tooltipText="$t('delete')"
          @icon-clicked="mutate(item, 'delete')"
          :disabled="!userAssignedClaim(UserClaims.GlobalAdmin)"
          elementId="end-use-sort-delete"/>
        </template>

      </DataTable>

    </v-container>
  </ShortcutWrapper>
</template>
<script>
import ProductHeaders from '@/headers/Product'
import { userAssignedClaim } from '@/utils/ClaimUtility'
import { UserClaims } from '@/utils/Enumerations.js'
import { uniqueDialogId } from '@/utils/componentHelpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EndUseSortSettings',

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    ShortcutWrapper: () => import('@/components/core/ShortcutWrapper.vue'),
    Dialog: () => import('@/components/Dialog.vue'),
    Icon: () => import('@/components/helper/Icon.vue'),
    EndUseSortForm: () => import('@/components/settings-components/product-settings/end-use-sort/EndUseSortForm.vue'),
    ConfirmDelete: () => import('@/components/helper/ConfirmDelete.vue')
  },

  data: () => ({
    UserClaims,
    dialogId: uniqueDialogId('end-use-sort-dialog'),
    deleting: false,
    endUseSort: null
  }),

  async mounted () {
    await this.fetchEndUseSorts()
  },

  computed: {
    ...mapGetters('end-use-sort', ['allEndUseSorts', 'endUseSortsLoading']),
    headers () {
      return ProductHeaders.endUseSortHeaders()
    },

    tableActions () {
      return [
        {
          icon: 'mdi-refresh',
          text: this.$t('refresh'),
          actionName: 'refresh'
        },
        {
          icon: 'mdi-plus',
          text: this.$t('newEndUseSort'),
          actionName: 'new-end-use-sort',
          disabled: !userAssignedClaim(UserClaims.GlobalAdmin)
        }
      ]
    },

    customCells () {
      return [
        {
          slotName: 'actions',
          value: 'actions'
        }
      ]
    }
  },

  methods: {
    ...mapActions('dialog', ['openOrUpdateDialog', 'closeDialogsAtOrAbove']),
    ...mapActions('end-use-sort', ['fetchEndUseSorts', 'deleteEndUseSort']),
    userAssignedClaim,

    refresh () {
      this.close()
      this.loading = true
      this.fetchEndUseSorts().finally(() => {
        this.loading = false
      })
    },

    mutate (endUseSort, mutationType) {
      this.endUseSort = JSON.parse(JSON.stringify(endUseSort))
      if (mutationType === 'delete') this.deleting = true
      this.openOrUpdateDialog(this.dialogId)
    },

    close () {
      this.deleting = false
      this.closeDialogsAtOrAbove(this.dialogId)
      this.endUseSort = undefined
    },

    async performDelete () {
      await this.deleteEndUseSort(this.endUseSort.endUseSortId)
      this.refresh()
    }
  }
}
</script>
